(()=>{
  const start=Date.parse('2026-10-31T00:00:00-07:00');
  const end=Date.parse('2026-11-02T00:00:00-08:00');
  const slot=document.querySelector('[data-rwh-product-slot]');
  const original=slot?.querySelector('[data-rwh-product-card]')?.cloneNode(true);
  const update=()=>{
    const now=Date.now();
    document.querySelectorAll('[data-rwh]').forEach(el=>{el.hidden=now>=end;});
    document.querySelectorAll('[data-rwh-schedule]').forEach(el=>{el.textContent=now<start?el.dataset.before:el.dataset.during;});
  };
  const place=()=>{
    if(!original||Date.now()>=end)return;
    const price=document.querySelector('.yj-price,.rw-product-price');
    if(!price||price.parentElement.querySelector('[data-rwh-product-card]'))return;
    price.insertAdjacentElement('afterend',original.cloneNode(true));
    if(slot)slot.hidden=true;
    update();
  };
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-rwh-copy]');
    if(!button||Date.now()>=end)return;
    const status=button.parentElement.querySelector('[data-rwh-status]');
    try{await navigator.clipboard.writeText('HALLOWEEN50');if(status)status.textContent=button.dataset.copied;}
    catch{if(status)status.textContent=button.dataset.manual;const range=document.createRange();range.selectNodeContents(button.querySelector('strong'));const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}
  });
  update();place();
  const product=document.querySelector('[data-rw-product]');
  if(product&&original)new MutationObserver(place).observe(product,{childList:true,subtree:true});
  const timer=setInterval(()=>{update();if(Date.now()>=end)clearInterval(timer);},15000);
  document.addEventListener('visibilitychange',update);
})();
